import { render, staticRenderFns } from "./giftSearch.vue?vue&type=template&id=183b0f00&scoped=true&"
import script from "./giftSearch.vue?vue&type=script&lang=js&"
export * from "./giftSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b0f00",
  null
  
)

export default component.exports